import React from 'react';

import { colors } from 'styles/theme/colors';

// Outline speech bubble — the Chat empty-state glyph, exact SVG from Figma ("No messages").
// Stroke rides a `color` prop defaulting to colors.black50 (the token already carries the
// design's 50% alpha — mirrors the clinical-notes copy of this icon so the two stay
// identical). Size defaults to the 34px natural size and is overridable via width/height
// (ChannelEmptyState renders it at 44).
export default function ChatBubbleIcon({
  width = 34,
  height = 34,
  color = colors.black50,
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={width} height={height} viewBox='0 0 34 34' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path d='M9.5 9.5H24.0714' stroke={color} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M9.5 16.7856H19.2143' stroke={color} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
      <path
        d='M30.1429 1H3.42857C2.78447 1 2.16676 1.25587 1.71131 1.71131C1.25587 2.16676 1 2.78447 1 3.42857V24.0714C1 24.7155 1.25587 25.3333 1.71131 25.7887C2.16676 26.244 2.78447 26.5 3.42857 26.5H8.28571V32.5714L15.8629 26.5H30.1429C30.7869 26.5 31.4047 26.244 31.8601 25.7887C32.3155 25.3333 32.5714 24.7155 32.5714 24.0714V3.42857C32.5714 2.78447 32.3155 2.16676 31.8601 1.71131C31.4047 1.25587 30.7869 1 30.1429 1Z'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
